
const fr = {
    message: {
        title1: "Contrôle à distance de la maison intelligente, technologie, sécurité et tranquillité d'esprit",
        content1:"AigoSmart vous aide à gérer et à contrôler à distance les appareils ménagers intelligents, et les appareils peuvent également se percevoir et se relier. Le déclenchement en un clic peut faire entrer divers appareils électroménagers dans votre état prédéfini, créant ainsi une maison intelligente sûre et sans souci pour vous la vie",
        title2:"AigoSmart est une nouvelle sous-marque d'Aigostar",
        content2:"Les produits sont actuellement vendus en Espagne, au Portugal, en France, en Italie, aux Pays-Bas, en Allemagne, en Finlande, au Danemark, en Pologne, en Russie, en Grèce, en Autriche, en Suisse, en République tchèque, en Hongrie, en Slovaquie et dans d'autres pays et régions européens",
        content3:" Les divers petits appareils ménagers de cuisine, de blanchisserie et de repassage d'AIGOSTAR continuent d'occuper",
        content4:" Dix principales ventes",
        title3:"Honneur de la marque",
        content5:"Rapide. Ouvrir. Innover. Persévérer",
        loading: 'Chargement',
        submit: 'Soumettre',
        contactUs:"Contactez-nous",
        privacy:"Accord de confidentialité",
        policy:"Service Policy",
        download:"Télécharger",

    },
}

export default fr;